import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Modal from "../modal/Modal";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./signaturePadModal.module.css";

interface SignaturePadModalProps {
  onClose: () => void;
  onConfirm: (signatureDataUrl: string) => void;
}

function SignaturePadModal({ onClose, onConfirm }: SignaturePadModalProps) {
  const signatureRef = useRef<SignatureCanvas>(null);
  const [hasDrawn, setHasDrawn] = useState(false);

  const handleClear = () => {
    signatureRef.current?.clear();
    setHasDrawn(false);
  };

  const handleConfirm = () => {
    const canvas = signatureRef.current;
    if (!canvas || canvas.isEmpty()) return;
    const dataUrl = canvas.toDataURL("image/png");
    onConfirm(dataUrl);
    onClose();
  };

  const handleEnd = () => {
    setHasDrawn(!signatureRef.current?.isEmpty());
  };

  return (
    <Modal onClose={onClose}>
      <article className={styles.signaturePad}>
        <h2 className={styles.signaturePad__title}>
          {t("SIGNATURE_PAD_TITLE")}
        </h2>
        <div className={styles.signaturePad__canvasWrapper}>
          <SignatureCanvas
            ref={signatureRef}
            canvasProps={{
              className: styles.signaturePad__canvas,
              width: 450,
              height: 200,
            }}
            penColor="black"
            backgroundColor="white"
            clearOnResize={false}
            onEnd={handleEnd}
          />
        </div>
        <div className={styles.signaturePad__buttons}>
          <button
            type="button"
            className={styles.signaturePad__clearBtn}
            onClick={handleClear}
          >
            {t("SIGNATURE_PAD_CLEAR")}
          </button>
          <button
            type="button"
            className={styles.signaturePad__confirmBtn}
            onClick={handleConfirm}
            disabled={!hasDrawn}
          >
            {t("SIGNATURE_PAD_CONFIRM")}
          </button>
          <button
            type="button"
            className={styles.signaturePad__cancelBtn}
            onClick={onClose}
          >
            {t("CANCEL")}
          </button>
        </div>
      </article>
    </Modal>
  );
}

export default SignaturePadModal;
